import { render } from "./PrivacyStatement.vue?vue&type=template&id=cad17890&ts=true"
import script from "./PrivacyStatement.vue?vue&type=script&lang=ts"
export * from "./PrivacyStatement.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__